import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../i18n';

import './LibraryPlayerAlert.scss';

const propTypes = {

	/**
	 * The text or DOM to display in the alert. Defaults
	 * to a generic error if no children are provided.
	 */
	children: PropTypes.node,

};

/**
 * The component that renders an error for the user
 * when there is no video available for playback with
 * an appearance similar to that of the video player.
 *
 * @param {Object} props  The component props.
 *
 * @returns {Object}      The LibraryPlayerAlert component.
 */
const LibraryPlayerAlert = (props) => {

	const { children } = props;

	const defaultMessage =
		<FormattedMessage {...messages.TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_ERROR} />;

	return (
		<div className="library-player-alert h4">
			{children || defaultMessage}
		</div>
	);

};

LibraryPlayerAlert.propTypes = propTypes;

export default LibraryPlayerAlert;
